import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/homeData';

export default function Testimonials() {
  const { t } = useTranslation();

  const col1 = testimonials.filter((_, i) => i % 3 === 0);
  const col2 = testimonials.filter((_, i) => i % 3 === 1);
  const col3 = testimonials.filter((_, i) => i % 3 === 2);

  function renderCard(item: typeof testimonials[0]) {
    return (
      <div key={item.id} className="bg-background-50 rounded-lg p-5 md:p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-secondary-100 overflow-hidden flex-shrink-0">
            <img
              src={item.avatar}
              alt={item.name}
              className="w-full h-full object-cover"
              title={item.name}
            />
          </div>
          <div>
            <div className="font-semibold text-sm text-foreground-900">{item.name}</div>
            <div className="text-xs text-foreground-400">{item.handle}</div>
          </div>
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed">
          &ldquo;{item.comment}&rdquo;
        </p>
        <div className="mt-3 text-xs text-foreground-400">{item.date}</div>
      </div>
    );
  }

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-600 text-xs font-semibold whitespace-nowrap mb-5">
            {t('testimonials.tag')}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
            {t('testimonials.title.line1')}
            <br />
            {t('testimonials.title.line2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="flex flex-col gap-5 md:gap-6">
            {col1.map(renderCard)}
          </div>
          <div className="flex flex-col gap-5 md:gap-6">
            {col2.map(renderCard)}
          </div>
          <div className="flex flex-col gap-5 md:gap-6">
            {col3.map(renderCard)}
          </div>
        </div>
      </div>
    </section>
  );
}